module.exports = __webpack_public_path__ + "static/media/TvShowBanner (12).8b6df5c8.png";